import routes from "../components/routes"
import useIsSmallScreen from "../hooks/useIsSmallScreen"
import DesktopNavigation from "./DesktopNavigation"
import MobileNavigation from "./MobileNavigation"

const StudentLayout = ({ children }) => {

    const isSmallScreen = useIsSmallScreen()

    const menuItems = [
        routes.studentLessons,
        routes.studentLogBook,
        routes.timetable
    ]

    return isSmallScreen ? (
        <MobileNavigation menuItems={menuItems}>
            {children}
        </MobileNavigation>
    ) : (
        <DesktopNavigation menuItems={menuItems}>
            {children}
        </DesktopNavigation>
    )

}

export default StudentLayout